/* eslint-disable jsx-a11y/alt-text */
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../utils/GlobalContext";
import CalenderImg from "../Assets/Img/Calender.png";
// import instagram from "../Assets/Img/Instagram.svg";
import NoCamp from "../Assets/Img/amico.svg";
// import facebook from "../Assets/Img/facebook.png";
import instaDeliverables from "../Assets/Img/insta deliverables.svg";
import youtubeDeliverables from "../Assets/Img/youtube deliverables.svg";
import "../Assets/css/influencer.css";
import filter from "../Assets/Img/filter btn collab-req.png";
import { Tooltip } from "@mui/material";
// import LinkedIn from "../Assets/Img/LinkedIn.png";
import DummyImg from "../Assets/Img/Rectangle 21.png";
import saveDark from "../Assets/Img/Savedark.svg";
import saveIconImg from "../Assets/Img/Saveicon.png";
// import Snapchat from "../Assets/Img/SnapChat.jpg";
// import youtube from "../Assets/Img/YouTube.svg";
// import quora from "../Assets/Img/quora.png";
// import reddit from "../Assets/Img/reddit.svg";
// import twitch from "../Assets/Img/twitch.png";
// import twitter from "../Assets/Img/twitter.png";
import axiosMain from "../http/axiosMain";
import { SearchBar } from "../Common/Components/SearchBar";
import { Calendar } from "lucide-react";
import CampaignCard from "../DummyContacts.js/CampaignCard";

function InfluencerHome() {
  // const inputFileRef = useRef();
  // const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  // const [loadingSave, setLoadingSave] = useState(false); // Track if the save action is loading
  // const [showContent, setShowContent] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  // const [filteredData, setFilteredData] = useState(data);
  // const [activeTab, setActiveTab] = useState("recent");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [step1, setStep1] = useState(true);
  const [otp, setOtp] = useState(true); // Assume OTP is true initially
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const { userData, setUserData } = useContext(GlobalContext);
  const [isSavedFiltered, setIsSavedFiltered] = useState(false);
  const [originalInfluencers, setOriginalInfluencers] = useState([]);
  const [selectedEngagement, setSelectedEngagement] = useState([]);
  const [selectedFollowers, setSelectedFollowers] = useState([]);
  const [selectedGender, setSelectedGender] = useState([]);

  const [selectedIndustry, setSelectedIndustry] = useState([]);
  const [selectedObjectives, setSelectedObjectives] = useState([]);
  const [selectedCollab, setSelectedCollab] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState([]); // store numeric weeks (e.g., "1")
  const [selectedContent, setSelectedContent] = useState([]);
  const [selectedBudget, setSelectedBudget] = useState([]);

  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("InfluencerActiveTab") || "onGoingCampaign";
  });

  const [activeFilterTab, setActiveFilterTab] = useState("objective");

  // for city
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  // const [bookmark, setBookmark] = useState(new Set());
  // for states
  const [states, setStates] = useState([]);
  const [selectedStates, setSelectedStates] = useState("");
  // const [openDropdown, setOpenDropdown] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [isrefreshModalOpen, setIsModalOpen] = useState(
    !(
      localStorage.getItem("brand_name") &&
      localStorage.getItem("brand_name").trim()
    )
  );
  const [savedCampaigns, setSavedCampaigns] = useState(new Set());

  const [isautopublishe, setIsAutoPublished] = useState([]);

  const [unlockedCampaigns, setUnlockedCampaigns] = useState(new Set());
  useEffect(() => {
    // Load previously unlocked campaigns from localStorage
    const unlocked = localStorage.getItem("unlockedCampaigns");
    if (unlocked) {
      setUnlockedCampaigns(new Set(JSON.parse(unlocked)));
    }
  }, []);

  const handleUnlockSuccess = (campaignId) => {
    // Mark campaign as unlocked in main data
    setData((prev) =>
      prev.map((item) =>
        item.campaign_id === campaignId
          ? { ...item, flag_paid_campaign: true }
          : item
      )
    );

    setOriginalInfluencers((prev) =>
      prev.map((item) =>
        item.campaign_id === campaignId
          ? { ...item, flag_paid_campaign: true }
          : item
      )
    );

    // ✅ Update unlockedCampaigns state
    setUnlockedCampaigns((prev) => {
      const updated = new Set(prev);
      updated.add(campaignId);
      localStorage.setItem("unlockedCampaigns", JSON.stringify([...updated]));
      return updated;
    });
  };

  //  const handleUnlockSuccess = (campaignId) => {
  //   setUnlockedCampaigns((prev) => new Set(prev).add(campaignId));
  // };

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const fetchCampaigns = async () => {
    try {
      const res = await axiosMain.get("/api/campaign/list");
      setIsAutoPublished(res.data || []);
    } catch (err) {
      console.error("Error fetching campaigns:", err);
    }
  };

  // const [isrefreshModalOpen, setIsModalOpen] = useState(!localStorage.getItem("brand_name"));

  const [profileDetails, setProfileDetails] = useState({
    brand_name: "",
    categories: [],
    bio: "",
    brand_website: "",
    social_links: "",
    state: "",
    pincode: "",
    user_photo: "",
    city: "",
    address: "",
    phone_no: "",
    email: "",
  });
  const [profileSetupDetails, setProfileSetupDetails] = useState({
    bio: "",
    website: "",
    social_Links: [
      { platform: "Instagram", url: "" },
      { platform: "YouTube", url: "" },
      { platform: "Facebook", url: "" },
      { platform: "LinkedIn", url: "" },
      { platform: "Snapchat", url: "" },
      { platform: "Twitch", url: "" },
      { platform: "Twitter", url: "" },
      { platform: "Reddit", url: "" },
      { platform: "Quora", url: "" },
    ],
  });

  const socialMediaPlatforms = [
    { name: "LinkedIn", placeholder: "Enter LinkedIn URL" },
    { name: "Snapchat", placeholder: "Enter Snapchat username" },
    { name: "Instagram", placeholder: "Enter Instagram username" },
    { name: "Twitter", placeholder: "Enter Twitter handle" },
    { name: "Facebook", placeholder: "Enter Facebook page URL" },
    { name: "Twitch", placeholder: "Enter Twitch username" },
    { name: "Reddit", placeholder: "Enter Reddit page URL" },
    { name: "Quora", placeholder: "Enter Quora page URL" },
  ];
  // const availablePlatforms = socialMediaPlatforms.filter(
  //   (platform) =>
  //     !profileSetupDetails.social_Links.some(
  //       (link) => link.platform === platform.name
  //     )
  // );
  // const handleSocialLinkChange = (index, value) => {
  //   const updatedLinks = [...profileSetupDetails.social_Links];
  //   updatedLinks[index].url = value;
  //   setProfileSetupDetails((prev) => ({
  //     ...prev,
  //     social_Links: updatedLinks,
  //   }));
  // };
  // const handleAddSocialLinks = () => {
  //   const newLinks = selectedPlatforms?.map((platform) => ({
  //     platform,
  //     url: "",
  //   }));
  //   setProfileSetupDetails((prev) => ({
  //     ...prev,
  //     social_Links: [...prev.social_Links, ...newLinks],
  //   }));
  //   setShowModal(false);
  //   setSelectedPlatforms([]);
  // };

  // const handleCheckboxChange1 = (platformName) => {
  //   setSelectedPlatforms((prev) =>
  //     prev.includes(platformName)
  //       ? prev.filter((p) => p !== platformName)
  //       : [...prev, platformName]
  //   );
  // };
  // const getPlatformIcon = (platform) => {
  //   switch (platform) {
  //     case "Instagram":
  //       return instagram;
  //     case "YouTube":
  //       return youtube;
  //     case "Facebook":
  //       return facebook;
  //     case "LinkedIn":
  //       return LinkedIn;
  //     case "Snapchat":
  //       return Snapchat;
  //     case "Twitch":
  //       return twitch;
  //     case "Twitter":
  //       return twitter;
  //     case "Reddit":
  //       return reddit;
  //     case "Quora":
  //       return quora;
  //     default:
  //       return null;
  //   }
  // };
  // const [showModal, setShowModal] = useState(false);
  // const [selectedPlatforms, setSelectedPlatforms] = useState([]);
  // const [selectedFile, setSelectedFile] = useState(null);
  // const [file, setFile] = useState(null);
  // const [selectedFilteName, setSelectedFilteName] = useState("");
  // const [selectedState, setSelectedState] = useState("");

  // const [contentTypes, setContentTypes] = useState([
  //   {
  //     platform: "Instagram",
  //     items: [
  //       { id: "reels", label: "Reels", count: 1, checked: false },
  //       { id: "posts", label: "Posts", count: 1, checked: false },
  //       { id: "story", label: "Story", count: 1, checked: false },
  //     ],
  //   },
  //   {
  //     platform: "YouTube",
  //     items: [
  //       { id: "shorts", label: "Shorts", count: 1, checked: false },
  //       { id: "video", label: "Video", count: 1, checked: false },
  //       { id: "liveStream", label: "Live Stream", count: 1, checked: false },
  //     ],
  //   },
  // ]);

  useEffect(() => {
    const email = sessionStorage.getItem("email");
    const phoneNo = sessionStorage.getItem("phone_no");

    if (email) {
      // If email exists, show only email and clear phone
      setUserEmail(email);
      setProfileDetails({
        email: email,
        phone: "", // Ensure phone is empty
      });
    } else if (phoneNo) {
      // If phone number exists, show only phone and clear email
      setProfileDetails({
        phone: phoneNo,
        email: "", // Ensure email is empty
      });
    } else {
      // If neither exists, clear both
      setProfileDetails({
        email: "",
        phone: "",
      });
    }
  }, []);

  // const handleIncrement = (platformIndex, itemIndex) => {
  //   const newContentTypes = [...contentTypes];
  //   newContentTypes[platformIndex].items[itemIndex].count += 1;
  //   setContentTypes(newContentTypes);
  // };

  useEffect(() => {
    if (otp) {
      setShowEditProfileModal(true);
    }
  }, [otp]); // for otp

  // const handleDecrement = (platformIndex, itemIndex) => {
  //   const newContentTypes = [...contentTypes];
  //   const currentCount = newContentTypes[platformIndex].items[itemIndex].count;
  //   if (currentCount > 0) {
  //     newContentTypes[platformIndex].items[itemIndex].count -= 1;
  //     setContentTypes(newContentTypes);
  //   }
  // };
  // const handleCheckboxChange = (category) => {
  //   setSelectedCategories((prev) =>
  //     prev.includes(category)
  //       ? prev.filter((c) => c !== category)
  //       : [...prev, category]
  //   );
  // };
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axiosMain.get("/api/v1/get-categories");
        if (response.data && response.data.categories) {
          setCategories(response.data.categories); // Store API response
        } else {
          console.error("Invalid category format received:", response.data);
          setCategories([]); // Fallback to empty array
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategories([]); // Fallback to empty array
      }
    };

    fetchCategories();
  }, []);
  // const handlePrevbtn = () => {
  //   if (currentStep > 1) {
  //     setCurrentStep((prevStep) => prevStep - 1);
  //   }
  // };
  // const handleStartDateChange = (e) => {
  //   setStartDate(e.target.value);
  //   setEndDate(""); // Reset end date when start date changes
  //   // setShowContent(false);
  // };
  const formatSingleDate = (dateString) => {
    if (!dateString) return ""; // Handle empty or invalid dates
    const date = new Date(dateString);

    // Ensure valid date
    if (isNaN(date.getTime())) return "";

    const day = date.getUTCDate(); // Use UTC to avoid timezone shifts
    const month = date.toLocaleString("default", { month: "short" }); // Example: Feb
    const suffix = getDaySuffix(day); // Get suffix like st, nd, rd, th

    return `${day}${suffix} ${month}`;
  };

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return "th"; // Special case for 11, 12, 13
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // const handleEndDateChange = (e) => {
  //   setEndDate(e.target.value);
  //   setLoading(true);
  //   // setShowContent(false);

  //   setTimeout(() => {
  //     setLoading(false);
  //     // setShowContent(true);
  //   }, 2000); // Show loader for 2 seconds
  // };

  // const currentDate = new Date().toISOString().split("T")[0];

  // const totalSteps = 4;

  // const handleNext = () => {
  //   setStep1(!step1);
  // };

  // const handlePrev = () => {
  //   setCurrentStep((prev) => Math.max(prev - 1, 1));
  // };
  // const [selectedAge, setSelectedAge] = useState(null);

  // const ageGroups = [
  //   "13-17",
  //   "18-24",
  //   "25-34",
  //   "35-44",
  //   "45-54",
  //   "55-64",
  //   "65+",
  // ];

  // const handleAgeSelect = (age) => {
  //   setSelectedAge(age);
  // };

  // const handleSaveDraft = () => {
  //   // Log save draft response here
  //   console.log("Draft Saved:", {
  //     startDate,
  //     endDate,
  //     contentTypes,
  //     selectedAge,
  //   });
  // };

  useEffect(() => {
    if (isSavedFiltered) {
      const filteredInfluencers = originalInfluencers.filter((influencer) =>
        savedCampaigns.has(influencer.campaign_id)
      );
      setData(filteredInfluencers);
    } else {
      setData([...originalInfluencers]);
    }
  }, [isSavedFiltered, savedCampaigns, originalInfluencers]);

  // const handlePublish = () => {
  //   // Log publish response here
  //   console.log("Campaign Published:", {
  //     startDate,
  //     endDate,
  //     contentTypes,
  //     selectedAge,
  //   });
  // };
  const ViewDetails = (id) => {
    localStorage.removeItem("dashboardpath");
    navigate(`/influancer-details/${id}`);
  };

  const navigate = useNavigate();
  // API Call for states
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await axiosMain.get("/api/v1/states");

        if (response?.data?.states && Array.isArray(response?.data?.states)) {
          setStates(response?.data?.states);
        } else {
          console.error("Invalid state data received:", response.data);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchStates();
  }, []);

  const createNavigate = () => {
    navigate("/campaign-create");
  };

  const getStatus = (tab) => {
    switch (tab) {
      case "onGoingCampaign":
        return "ongoing";
      case "upcomingCampaign":
        return "upcoming";
      case "finishedCampaign":
        return "finished";
      default:
        return null;
    }
  };

  const fetchData = async (searchQuery = "", status = null, isSearch = true) => {
    setLoading(true);
    setError(null);

    try {
      let apiUrl = `/api/v1/all`;
      let params = {};

      if (isSearch && searchQuery !== "") {
        params = { search: searchQuery };
      } else {
        apiUrl += `?${searchQuery}`;
      }

      // Add status to params if provided
      if (status) {
        if (isSearch && searchQuery !== "") {
          params.campaign_status = status;
        } else {
          apiUrl += `${searchQuery ? '&' : '?' }campaign_status=${status}`;
        }
      }

      const response = await axiosMain.get(apiUrl, { params });

      // console.log("Response Data:", response.data);

      if (!response.data?.campaigns) {
        throw new Error("Invalid API response structure");
      }

      if (isSavedFiltered) {
        // TODO: Implement saved filter logic if needed
      }

      const now = new Date();
      const campaigns = response.data.campaigns;

      // Adjust client-side filter based on status, or remove if server handles it
      // Assuming server filters by status, we can simplify to just exclude drafts
      // If server doesn't filter, uncomment and adjust the status-specific filters below
      const filteredCampaigns = campaigns.filter((campaign) => {
        // Always exclude drafts
        if (campaign.issavedasdraft === 1) return false;

        // If no status, filter for ongoing (as before)
        if (!status) {
          const startDate = new Date(campaign.start_date);
          const endDate = new Date(campaign.end_date);
          return startDate <= now && endDate >= now;
        }

        // Status-specific filters (use these if server doesn't filter)
        const startDate = new Date(campaign.start_date);
        const endDate = new Date(campaign.end_date);

        switch (status) {
          case "upcoming":
            return startDate > now;
          case "ongoing":
            return startDate <= now && endDate >= now;
          case "finished":
            return endDate < now;
          default:
            return true; // No filter
        }
      });

      // Extract saved campaign IDs
      const savedCampaignIds = new Set(
        filteredCampaigns
          .filter((campaign) => campaign.flag_saved_campaign)
          .map((campaign) => campaign.campaign_id)
      );

      // Update state
      setData(filteredCampaigns);
      setOriginalInfluencers(filteredCampaigns);
      setSavedCampaigns(savedCampaignIds);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  // Initial load based on activeTab
  useEffect(() => {
    const status = getStatus(activeTab);
    fetchData("", status, false);
  }, [activeTab]);

  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

  const isautopublished = data?.filter((ele) => ele);

  // const handleSearch = (e) => {
  //   const query = e.target.value.toLowerCase();
  //   setSearchQuery(query); // Update searchQuery state

  //   // Trigger the fetchData function when search query changes
  //   if (query?.length > 0) {
  //     fetchData(query); // Fetch data with the updated search query
  //   } else {
  //     fetchData(); // Fetch all data if the search query is empty
  //   }
  // };

  function debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }

  const debouncedFetch = useRef(
    debounce((query, status) => {
      fetchData(query, status, true);
    }, 400) // 400ms delay
  ).current;

  const handleSearchQueryChange = (queryOrEvent) => {
    const query =
      typeof queryOrEvent === "string"
        ? queryOrEvent
        : queryOrEvent.target.value.toLowerCase();

    setSearchQuery(query);

    const status = getStatus(activeTab);

    if (query.length > 0) {
      debouncedFetch(query, status); // only ONE API call after user stops typing
    } else {
      fetchData("", status, false); // reset full data for current status
    }
  };

  const isModalOpen = localStorage.getItem("openModal") === "true";

  const handleCloseEditProfileModal = () => {
    setShowEditProfileModal(false);
    setIsModalOpen(false); // Close the modal
  };

  const handleSaveBookmark = () => {
    console.log("isSavedFiltered:", isSavedFiltered);

    if (isSavedFiltered) {
      // Restore all data
      setData([...originalInfluencers]);
      setIsSavedFiltered(false);
    } else {
      const savedInfluencers = originalInfluencers.filter(
        (influencer) => influencer.flag_saved_campaign
      );

      setIsSavedFiltered(true);
      setData(savedInfluencers.length > 0 ? savedInfluencers : []);
    }
  };

  const handleFileSelect = async (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();

      // Convert to ArrayBuffer for backend upload
      reader.onload = async (event) => {
        const arrayBuffer = event.target.result;
        const buffer = new Uint8Array(arrayBuffer); // Convert to Uint8Array

        const fileData = {
          fieldname: "logo",
          originalname: selectedFile.name,
          encoding: "7bit",
          mimetype: selectedFile.type,
          buffer: buffer,
          size: selectedFile.size,
        };

        // Generate a Data URL for preview
        const previewReader = new FileReader();
        previewReader.onload = (e) => {
          setProfileDetails((prev) => ({
            ...prev,
            logo: fileData, // Store file for backend
            logoPreview: e.target.result, // Image preview
          }));

          // Update userData for Navbar using GlobalContext
          setUserData((prev) => ({
            ...prev,
            user_photo: e.target.result,
          }));
        };

        previewReader.readAsDataURL(selectedFile); // Read image as Data URL
      };

      reader.readAsArrayBuffer(selectedFile); // Read as ArrayBuffer
    }
  };

  // const handleFileSelect = async (e) => {
  //   // debugger;
  //   const selectedFile = e.target.files[0];
  //   if (selectedFile) {
  //     const reader = new FileReader();

  //     reader.onload = async (event) => {
  //       const arrayBuffer = event.target.result;

  //       const buffer = new Uint8Array(arrayBuffer); // Convert ArrayBuffer to Uint8Array

  //       // Create an object similar to what the backend expects
  //       const fileData = {
  //         fieldname: "logo",
  //         originalname: selectedFile.name,
  //         encoding: "7bit",
  //         mimetype: selectedFile.type,
  //         buffer: buffer, // This is a Uint8Array, similar to a Buffer in Node.js
  //         size: selectedFile.size,
  //       };

  //       // setFile(fileData);
  //       // setSelectedFilteName(selectedFile.name);
  //       setProfileDetails({ ...profileDetails, logo: fileData });
  //     };

  //     reader.readAsArrayBuffer(selectedFile); // Read file as ArrayBuffer (binary data)
  //   }
  // };

  // const handleSave = async () => {
  //   // setLoadingSave(true); // Start loading when save button is clicked

  //   const requestBody = {
  //     brand_name: profileDetails.name || "",
  //     categories: selectedCategories.join(", ") || "",
  //     bio: profileSetupDetails.bio || "",
  //     brand_website: profileSetupDetails.website || "",
  //     // social_links: JSON.stringify(profileSetupDetails.socialLinks) || "",
  //     // flat_apartment: profileDetails.address || "",
  //     city: selectedCity || "",
  //     address: profileDetails.address || "",
  //     state: selectedStates[0]?.name || "",
  //     pincode: profileDetails.pin || "",
  //     file: profileDetails.logo || "",
  //     phone_no: profileDetails.phone || "",
  //     email: profileDetails.email || "",
  //     instagram: profileSetupDetails?.social_Links?.find(
  //       (i) => i.platform.toLowerCase() === "instagram"
  //     )?.url,
  //     facebook: profileSetupDetails?.social_Links?.find(
  //       (i) => i.platform.toLowerCase() === "facebook"
  //     )?.url,
  //     linkedin: profileSetupDetails?.social_Links?.find(
  //       (i) => i.platform.toLowerCase() === "linkedin"
  //     )?.url,
  //     youtube: profileSetupDetails?.social_Links?.find(
  //       (i) => i.platform.toLowerCase() === "youtube"
  //     )?.url,
  //   };

  //   // localStorage.setItem("profileDetails", JSON.stringify(requestBody));

  //   // Create a FormData object
  //   const formData = new FormData();

  //   // Append non-file fields
  //   Object.keys(requestBody).forEach((key) => {
  //     if (key === "file") {
  //       // debugger;
  //       const fileData = requestBody.file;

  //       if (fileData?.buffer) {
  //         const blob = new Blob([fileData.buffer], { type: fileData.mimetype });
  //         formData.append("file", blob, fileData.originalname);
  //       } else if (fileData instanceof File) {
  //         formData.append("file", fileData);
  //       }
  //     }
  //     // if (key === "brand_name") {
  //     //   formData.append("brand_name", requestBody.brand_name);
  //     // }
  //     // if (key === "categories") {
  //     //   formData.append("categories", requestBody.categories);
  //     // }
  //     // if (key === "bio") {
  //     //   formData.append("bio", requestBody.bio);
  //     // }
  //     // if (key === "brand_website") {
  //     //   formData.append("brand_website", requestBody.brand_website);
  //     // }
  //     // if (key === "city") {
  //     //   formData.append("city", requestBody.city);
  //     // }
  //     // if (key === "address") {
  //     //   formData.append("address", requestBody.address);
  //     // }
  //     // if (key === "state") {
  //     //   formData.append("state", requestBody.state);
  //     // }
  //     // if (key === "pincode") {
  //     //   formData.append("pincode", requestBody.pincode);
  //     // }
  //     // if (key === "email") {
  //     //   formData.append("email", requestBody.email);
  //     // }
  //     // if (key === "phone_no") {
  //     //   formData.append("phone_no", requestBody.phone_no);
  //     // }
  //     // if (key === "brand_name") {
  //     //   formData.append("brand_name", profileDetails.brand_name);
  //     // }
  //     //  else {
  //     //  else {
  //     formData.append(key, requestBody[key]);
  //     // }
  //   });

  //   try {
  //     const response = await axiosMain.post("/api/v1/brand-profile", formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data", // Ensure correct content type
  //       },
  //     });

  //     console.log("API Response:", response.data);
  //     localStorage.setItem("brand_name", requestBody.brand_name); // Store brand name
  //     setIsModalOpen(false); // Close modal

  //     handleCloseEditProfileModal();
  //   } catch (error) {
  //     console.error("Error fetching profile:", error);
  //     // setLoadingSave(false); // Stop loading if there's an error
  //   }
  // };

  // ✅ Fetch Cities based on State ID
  // const fetchCities = async (stateId) => {
  //   if (!stateId) {
  //     console.error("Invalid State ID");
  //     return;
  //   }

  //   try {
  //     const response = await axiosMain.get(`/api/v1/states/${stateId}/cities`);
  //     console.log("Cities API Response:", response?.data);

  //     if (response?.data?.cities) {
  //       setCities(response?.data?.cities); // ✅ Update cities state
  //       console.log("response", response?.data?.cities);
  //     } else {
  //       console.error("No cities found or invalid response structure");
  //       setCities([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching cities:", error);
  //     setCities([]);
  //   }
  // };

  // const handleStateSelect = (state) => {
  //   if (state?.id) {
  //     setSelectedStates([state]); // ✅ Store selected state
  //     setSelectedCity(""); // Reset city
  //     fetchCities(state?.id); // ✅ Fetch cities using the correct state ID
  //   } else {
  //     console.error("Invalid State or Missing ID");
  //   }
  // };

  const handleSaveCampaign = async (campaignId) => {
    try {
      // Determine action based on current state BEFORE making API call
      const isCurrentlySaved = savedCampaigns.has(campaignId);
      const action = isCurrentlySaved ? "unsave" : "save";
      console.log("action...", action);

      const response = await axiosMain.post("/api/v1/save-campaign", {
        campaignId: campaignId,
        action: action,
      });

      if (response.status === 200) {
        // Update savedCampaigns state
        const newSavedCampaigns = new Set(savedCampaigns);
        if (action === "save") {
          newSavedCampaigns.add(campaignId);
        } else {
          newSavedCampaigns.delete(campaignId);
        }

        setSavedCampaigns(newSavedCampaigns);

        // Update filtered data if needed
        if (isSavedFiltered) {
          const filteredInfluencers = originalInfluencers.filter((influencer) =>
            newSavedCampaigns.has(influencer.campaign_id)
          );
          setData(filteredInfluencers);
        }
      } else {
        console.error("Error: Campaign save action failed");
      }
    } catch (error) {
      console.error(
        "Error saving campaign:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const [open, setOpen] = useState(false);

  const toggle = (list, setList, value) => {
    if (list.includes(value)) setList(list.filter((i) => i !== value));
    else setList([...list, value]);
  };

  const handleClearAll = () => {
    setSelectedIndustry([]);
    setSelectedObjectives([]);
    setSelectedCollab([]);
    setSelectedDuration([]);
    setSelectedContent([]);
    setSelectedBudget([]);
  };

  const contentFormatToKeys = (label) => {
    switch (label) {
      case "Reel/Shorts":
        return ["reels", "shorts"];
      case "Post/Carousel":
        return ["posts"];
      case "Stories":
        return ["story"];
      case "Live Session":
        return ["live_stream"];
      default:
        return [];
    }
  };

  const budgetLabelToRange = (label) => {
    const clean = label.replace(/k|K|,|₹/g, "");
    const [a, b] = clean
      .split("-")
      .map(
        (s) => parseFloat(s) * (s.toLowerCase().includes("m") ? 1000000 : 1)
      );

    const map = {
      "5k-50k": [5000, 50000],
      "50k-100k": [50000, 100000],
      "100k-200k": [100000, 200000],
      "200k-300k": [200000, 300000],
      "300k-400k": [300000, 400000],
      "400k-500k": [400000, 500000],
      "500k-600k": [500000, 600000],
      "600k-700k": [600000, 700000],
      "700k-800k": [700000, 800000],
      "800k-900k": [800000, 900000],
      "900k-1M": [900000, 1000000],
    };
    return map[label] || [null, null];
  };

  const handleApply = async () => {
    const params = new URLSearchParams();

    if (selectedIndustry.length)
      params.append("industry", selectedIndustry.join(","));
    if (selectedObjectives.length)
      params.append("campaign_primary_objective", selectedObjectives.join(","));
    if (selectedCollab.length)
      params.append("compensation_type", selectedCollab.join(","));
    if (selectedDuration.length) {
      // store as numeric weeks: e.g ['1 week','2 week'] => [1,2]
      params.append(
        "duration_weeks",
        selectedDuration.map((d) => d.split(" ")[0]).join(",")
      );
    }
    if (selectedContent.length) {
      // send content types as comma separated DB keys (allowed: shorts,videos,live_stream,posts,reels,story)
      const keys = selectedContent.flatMap((c) => contentFormatToKeys(c));
      // dedupe
      const unique = Array.from(new Set(keys));
      params.append("content_types", unique.join(","));
    }
    if (selectedBudget.length) {
      // send budget ranges as e.g. 5000-50000,50000-100000
      const ranges = selectedBudget.map((b) => budgetLabelToRange(b).join("-"));
      params.append("budget_ranges", ranges.join(","));
    }

    const status = getStatus(activeTab);
    fetchData(params.toString(), status, false);

    setOpen(false);
  };
  const toggleCategory = (id) => {
    setSelectedCategories((prev) =>
      prev.includes(id) ? prev.filter((cat) => cat !== id) : [...prev, id]
    );
  };
  const toggleItem = (list, setList, value) => {
    if (list.includes(value)) {
      setList(list.filter((item) => item !== value));
    } else {
      setList([...list, value]);
    }
  };

  const toggleEngagement = (e) =>
    toggleItem(selectedEngagement, setSelectedEngagement, e);
  const toggleFollowers = (f) =>
    toggleItem(selectedFollowers, setSelectedFollowers, f);
  const toggleGender = (g) => toggleItem(selectedGender, setSelectedGender, g);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    localStorage.setItem("InfluencerActiveTab", tab);
  };

  return (
    <>
      <div className="campaignCreate">
        <div className="justify-content-end">
          <div className="SearchFilterSection">
            <div className="d-flex justify-content-between align-items-center w-100">
              {/* Left Side Tabs */}
              <div style={{ display: "flex", gap: "24px" }}>
                <div
                  onClick={() => handleTabChange("onGoingCampaign")}
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "20px",
                    cursor: "pointer",
                    padding: "8px 12px",
                    borderBottom:
                      activeTab === "onGoingCampaign"
                        ? "2px solid #6B8E76"
                        : "2px solid transparent",
                    color:
                      activeTab === "onGoingCampaign" ? "#1D1B20" : "#49454F",
                  }}
                >
                  On Going Campaign
                </div>

                <div
                  onClick={() => handleTabChange("upcomingCampaign")}
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "20px",
                    cursor: "pointer",
                    padding: "8px 12px",
                    borderBottom:
                      activeTab === "upcomingCampaign"
                        ? "2px solid #6B8E76"
                        : "2px solid transparent",
                    color:
                      activeTab === "upcomingCampaign" ? "#1D1B20" : "#49454F",
                  }}
                >
                  Upcoming Campaign
                </div>

                <div
                  onClick={() => handleTabChange("finishedCampaign")}
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "20px",
                    cursor: "pointer",
                    padding: "8px 12px",
                    borderBottom:
                      activeTab === "finishedCampaign"
                        ? "2px solid #6B8E76"
                        : "2px solid transparent",
                    color:
                      activeTab === "finishedCampaign" ? "#1D1B20" : "#49454F",
                  }}
                >
                  Finished Campaign
                </div>
              </div>

              {/* Right Side Search & Filter */}
              <div
                className="d-flex align-items-center"
                style={{ gap: "12px" }}
              >
                <div className="SearchInput barr position-relative">
                  <SearchBar
                    searchQuery={searchQuery}
                    setSearchQuery={handleSearchQueryChange}
                  />
                </div>
                <div className="filter-icon-container">
                  <img
                    src={filter}
                    alt="Filter"
                    className="filter-icon"
                    onClick={() => setOpen(true)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {data.length === 0 && (searchQuery || /* isSavedFiltered */ false) ? (
          <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center px-4 max-w-md mx-auto">
              <img src={NoCamp} alt="No Campaigns" className="object-contain" />
              <h2 className="Title">Welcome to the Campaign!</h2>
              <p className="text-gray-600 mb-8">
                Currently, there are no saved campaigns available.
              </p>
            </div>
          </div>
        ) : (
          <div className="CreatedCampaigns influencer-home mt-4">
            <div className="tab-content">
              <div className="row g-4">
                {isautopublished.map((ele, index) => {
                  return (
                    <div
                      key={ele.campaign_id}
                      className="col-xl-3 col-lg-4 col-md-6"
                    >
                      {ele?.flag_paid_campaign === true ? (
                        <div className="campaign-card">
                          <div className="SaveIcon influencer-home">
                            <img
                              src={
                                savedCampaigns.has(ele.campaign_id)
                                  ? saveDark
                                  : saveIconImg
                              }
                              className="img-fluid"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSaveCampaign(ele.campaign_id);
                              }}
                              style={{ cursor: "pointer" }}
                              alt="Save Icon"
                            />
                          </div>
                          <div className="influencer-home-image">
                            <img
                              src={ele.campaign_poster || DummyImg}
                              alt={ele.campaign_title}
                              className="campaign-image influencer-home w-100"
                            />
                          </div>
                          <div className="p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <div className="StatusCamp">
                                <Tooltip title={ele.campaign_title}>
                                  <h5 className="mb-1 campaign-title">
                                    {ele.campaign_title
                                      ?.charAt(0)
                                      .toUpperCase() +
                                      ele.campaign_title?.slice(1)}
                                  </h5>
                                </Tooltip>
                                <span
                                  className={`status-badge CreatedShap ${
                                    ele.request_status === null
                                      ? "transparent-bg"
                                      : ele.request_status ===
                                        "Request Rejected"
                                      ? "bg-reject"
                                      : ele.request_status === "Request Sent"
                                      ? "bg-sent"
                                      : ele.request_status ===
                                        "Request Accepted"
                                      ? "bg-received"
                                      : ""
                                  }`}
                                >
                                  {ele.request_status || ""}
                                </span>
                              </div>
                            </div>
                            <div className="influencer-home-brand-name">
                              <p>{ele.brand_name}</p>
                            </div>
                            <div className="d-flex align-items-center mb-2">
                              <span className="influencer-home-date">
                                <Calendar size={15} className="me-1" />
                                {formatSingleDate(ele.start_date)} -{" "}
                                {formatSingleDate(ele.end_date)}
                              </span>
                            </div>
                            <hr />
                            <div className="influencer-home-product-tag">
                              <div>Product</div>
                              <div>
                                <p>{ele.campaign_title}</p>
                              </div>
                            </div>
                            <div className="influencer-home-budget-page">
                              <div>Budget</div>
                              <div>
                                <p>{ele.budget}</p>
                              </div>
                            </div>
                            <div className="mb-3">
                              <p className="mb-2">Deliverables</p>
                              <div className="d-flex">
                                {(() => {
                                  const firstWeek = ele.timeline?.[0];
                                  const hasIG =
                                    firstWeek?.Instagram &&
                                    (firstWeek.Instagram.posts > 0 ||
                                      firstWeek.Instagram.reels > 0 ||
                                      firstWeek.Instagram.story > 0);
                                  const hasYT =
                                    firstWeek?.YouTube &&
                                    (firstWeek.YouTube.shorts > 0 ||
                                      firstWeek.YouTube.videos > 0 ||
                                      firstWeek.YouTube.live_stream > 0);

                                  return (
                                    <>
                                      {hasIG && (
                                        <img
                                          src={instaDeliverables}
                                          alt="Instagram"
                                          className="social-media-icon-campaign me-3"
                                        />
                                      )}
                                      {hasYT && (
                                        <img
                                          src={youtubeDeliverables}
                                          alt="YouTube"
                                          className="social-media-icon-campaign"
                                        />
                                      )}
                                    </>
                                  );
                                })()}
                              </div>
                            </div>
                          </div>
                          <div className="CardBtn">
                            <button
                              onClick={() => ViewDetails(ele.campaign_id)}
                            >
                              View Details
                            </button>
                          </div>
                        </div>
                      ) : (
                        <CampaignCard
                          ele={ele}
                          savedCampaigns={savedCampaigns}
                          handleSaveCampaign={handleSaveCampaign}
                          formatSingleDate={formatSingleDate}
                          fetchData={fetchData}
                          onUnlockSuccess={handleUnlockSuccess}
                          onUnlockCampaign={handleUnlockSuccess} // ✅ use correct prop name here
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>

      {open && (
        <div className="filter-overlay">
          <div className="filter-sidebar">
            <div className="filter-header d-flex justify-content-between align-items-center">
              <h5>Filters</h5>
              <button
                onClick={() => setOpen(false)}
                className="btn-close"
              ></button>
            </div>

            <div className="FilterBox">
              <div className="filter-tabs">
                {/* <div
                  className={`tab ${
                    activeFilterTab === "industry" ? "active" : ""
                  }`}
                  onClick={() => setActiveFilterTab("industry")}
                >
                  Industry/Niche
                </div> */}
                <div
                  className={`tab ${
                    activeFilterTab === "objective" ? "active" : ""
                  }`}
                  onClick={() => setActiveFilterTab("objective")}
                >
                  Campaign Objective
                </div>
                <div
                  className={`tab ${
                    activeFilterTab === "collab" ? "active" : ""
                  }`}
                  onClick={() => setActiveFilterTab("collab")}
                >
                  Collaboration Type
                </div>
                <div
                  className={`tab ${
                    activeFilterTab === "duration" ? "active" : ""
                  }`}
                  onClick={() => setActiveFilterTab("duration")}
                >
                  Campaign Duration
                </div>
                <div
                  className={`tab ${
                    activeFilterTab === "content" ? "active" : ""
                  }`}
                  onClick={() => setActiveFilterTab("content")}
                >
                  Content Format
                </div>
                <div
                  className={`tab ${
                    activeFilterTab === "budget" ? "active" : ""
                  }`}
                  onClick={() => setActiveFilterTab("budget")}
                >
                  Budget Range
                </div>
              </div>

              <div className="category-list" style={{ padding: 16 }}>
                {activeFilterTab === "industry" &&
                  CATEGORY_OPTIONS.map((c, i) => (
                    <div key={i} className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`ind-${i}`}
                        checked={selectedIndustry.includes(c)}
                        onChange={() =>
                          toggle(selectedIndustry, setSelectedIndustry, c)
                        }
                      />
                      <label className="form-check-label" htmlFor={`ind-${i}`}>
                        {c}
                      </label>
                    </div>
                  ))}

                {activeFilterTab === "objective" &&
                  OBJECTIVE_OPTIONS.map((c, i) => (
                    <div key={i} className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`obj-${i}`}
                        checked={selectedObjectives.includes(c)}
                        onChange={() =>
                          toggle(selectedObjectives, setSelectedObjectives, c)
                        }
                      />
                      <label className="form-check-label" htmlFor={`obj-${i}`}>
                        {c}
                      </label>
                    </div>
                  ))}

                {activeFilterTab === "collab" &&
                  COLLAB_OPTIONS.map((c, i) => (
                    <div key={i} className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`col-${i}`}
                        checked={selectedCollab.includes(c)}
                        onChange={() =>
                          toggle(selectedCollab, setSelectedCollab, c)
                        }
                      />
                      <label className="form-check-label" htmlFor={`col-${i}`}>
                        {c}
                      </label>
                    </div>
                  ))}

                {activeFilterTab === "duration" &&
                  DURATION_OPTIONS.map((c, i) => (
                    <div key={i} className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`dur-${i}`}
                        checked={selectedDuration.includes(c)}
                        onChange={() =>
                          toggle(selectedDuration, setSelectedDuration, c)
                        }
                      />
                      <label className="form-check-label" htmlFor={`dur-${i}`}>
                        {c}
                      </label>
                    </div>
                  ))}

                {activeFilterTab === "content" &&
                  CONTENT_OPTIONS.map((c, i) => (
                    <div key={i} className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`cont-${i}`}
                        checked={selectedContent.includes(c)}
                        onChange={() =>
                          toggle(selectedContent, setSelectedContent, c)
                        }
                      />
                      <label className="form-check-label" htmlFor={`cont-${i}`}>
                        {c}
                      </label>
                    </div>
                  ))}

                {activeFilterTab === "budget" &&
                  BUDGET_OPTIONS.map((c, i) => (
                    <div key={i} className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`bud-${i}`}
                        checked={selectedBudget.includes(c)}
                        onChange={() =>
                          toggle(selectedBudget, setSelectedBudget, c)
                        }
                      />
                      <label className="form-check-label" htmlFor={`bud-${i}`}>
                        {c}
                      </label>
                    </div>
                  ))}
              </div>
            </div>

            <div className="filter-footer d-flex justify-content-between mt-3">
              <button
                className="btn btn-link text-muted"
                onClick={handleClearAll}
              >
                Clear All
              </button>
              <button className="btn btn-success" onClick={handleApply}>
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default InfluencerHome;
const CATEGORY_OPTIONS = ["Fashion", "Travel", "Tech", "Beauty", "Fitness"];
const OBJECTIVE_OPTIONS = [
  "Brand Awareness",
  "Product Promotion",
  "App Downloads",
  "Lead Generation",
  "Engagement (Likes, Comments, Shares)",
];
const COLLAB_OPTIONS = [
  "Product Exclusivity",
  "Monetary Compensation",
  "Experiences",
];
const DURATION_OPTIONS = Array.from({ length: 12 }, (_, i) => `${i + 1} week`);
const CONTENT_OPTIONS = [
  "Reel/Shorts",
  "Post/Carousel",
  "Stories",
  "Live Session",
]; // Blog/Article omitted (not in DB)
const BUDGET_OPTIONS = [
  "5k-50k",
  "50k-100k",
  "100k-200k",
  "200k-300k",
  "300k-400k",
  "400k-500k",
  "500k-600k",
  "600k-700k",
  "700k-800k",
  "800k-900k",
  "900k-1M",
];